/**
 * Move Element to another Container
 * 
 * @param html element
 * @param html container
 */

export const moveElementToContainer = (element, container) => {
    if (element && container) {
        // element.remove()
        container.appendChild(element)
    } else {
        console.log('Missing params in function moveElementToContainer(element, container)', [element, container])
    }
}

/**
 * Create New Element
 * 
 * @param string element
 * @param array elementClasses
 * @param string text
 * 
 * @retrun html
 */

export const createNewElement = (element, elementClasses, text = '') => {
    if (element && elementClasses && text != null) {
        const result = document.createElement(element)
        elementClasses.forEach(elementClass => {
            result.classList.add(elementClass)
        })
        result.innerHTML = text
        return result
    } else {
        console.log('Missing params in function createNewElement(element, elementClasses, text)', [element, elementClasses, text])
    }
}

/**
 * Format Product
 * 
 * @param array slides
 */

export const formatProducts = (products) => {
    if (products) {
        products.forEach(product => {
            const linkUrl = product.querySelector('.product-box__header a').href
                , imageUrl = product.querySelector('.product-box__image img').src
                , title = product.querySelector('.product-box__title').innerHTML
                , price = (product.querySelector('.product-box__price'))
                , action = product.querySelector('.product-box__action')
                , message = product.querySelector('.product-box__notavailable')

            const prodLink = createNewElement('a', ['prod-link'])
            prodLink.href = linkUrl
            prodLink.target = '_self'

            const prodImage = createNewElement('img', ['prod-image'])
            prodImage.src = imageUrl
            prodImage.alt = title

            prodLink.append(prodImage)
            prodLink.append(createNewElement('h3', ['prod-title'], title))

            const prodInfo = createNewElement('div', ['prod-info'])

            if (price && action) {
                prodInfo.append(createNewElement('div', ['prod-price'], price.innerHTML))
                prodInfo.append(createNewElement('div', ['prod-action'], action.innerHTML))
            } else if (message) {
                prodInfo.append(createNewElement('div', ['prod-message'], message.innerHTML))
            }

            product.append(prodLink)
            product.append(prodInfo)

        })
    } else {
        console.log('Missing params in function formatProducts(products)', [products])
    }
}

/**
 * At menu Click load function
 * 
 * @param function funct
 */

export const atMenuLinkClick = (funct) => {
    const menuBtns = document.querySelectorAll('.site-nav__menu__link')
    menuBtns.forEach(menuBtn => {
        menuBtn.addEventListener('click', () => {
            funct()
        })
    })
}

/**
* Force Page Refresh
* 
* @param html btn
*/

export const forcePageRefresh = (btn) => {
   if(btn) {
       btn.addEventListener('click', (e) => {
           e.preventDefault()
           let url = ''
           if(btn instanceof HTMLAnchorElement) {
              url = btn.href
           } else if(btn instanceof HTMLButtonElement) {
              url = window.location.href
           }
           window.location.href = url
       })
   } else {
       console.log('Missimg params in fucntion forcePageRefresh(btn)', [btn])
   }
}